import { c as _c } from "react/compiler-runtime";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
export const RightArrow = t0 => {
  const $ = _c(2);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick) {
    t1 = <KeyboardArrowRightIcon aria-label="KeyboardArrowRight" onClick={onClick} />;
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};